import View from "../framework/view";
import template from "../../pugc/shop-collections";
import Server from "../server";
import {Collection} from "../bo/collection";
import Alerts from "../misc/alerts";
import {GrapesTemplate} from "../bo/website";
import jQuery from "jquery";
import {Spinner} from "./spinner";

const classname = "shop-collections-view";

const server = Server.instance();

export class ShopCollectionsView extends View {

    private collections?: Collection[];

    private slugUse: any = {};

    constructor() {
        super(classname);
        this.load();
    }

    async load() {

        const spinner = Spinner.pushSpinner();

        let collections = await server.collections();
        let website = await server.website();

        const menus = website.menus || [];

        const templates : { [url:string] : GrapesTemplate } = {};

        for (const menu of menus) {
            for (const item of (menu.items || [])) {
                if (item.item_type == "page" && item.url) {
                    const url = item.url;

                    if (! templates[url]) {
                        try {
                            templates[url] = await server.template(url.split("/"), {
                                silent: true
                            });
                        } catch (ex) {
                            console.log(`Missing template for ${url}`);
                        }
                    }

                }
            }
        }

        const slugUse : any = {};

        for (const url in templates) {
            const t = jQuery(templates[url].html || "");

            const galleries = t.find("tp-gallery");
            galleries.each((index, element) => {
                const gallery = jQuery(element);
                const slug = gallery.data("slug") || "all-products" as string;
                if (! slugUse[slug]) {
                    slugUse[slug] = [];
                }
                slugUse[slug].push(url);
            });
        }

        this.slugUse = slugUse;

        // take copy before sorting
        collections = collections.slice();
        collections.sort((a, b) => {
            return (a.name || "").localeCompare(b.name || "");
        });
        this.collections = collections;

        this.update();

        spinner();
    }

    protected render0(): JQuery<HTMLElement> {

        const data = {
            collections: this.collections,
            slugUse: this.slugUse
        };

        const out = this.pug(template, data);
        return out;
    }

    async add() {
        const name = (this.elt().find("input[name=collection]").val() as string || "").trim();
        if (name == "") {
            return;
        }
        const c: Collection = {
            name: name,
            product_names: []
        };

        await server.saveCollection(c);
        this.load();
        Alerts.alert(`Created collection ${name}`);
    }

}

View.on(
    "." + classname,
    "click",
    "button.add-collection",
    function(that: ShopCollectionsView, event, elt) {
        event.preventDefault();
        that.add();
    });

